import React from 'react';
import { ActionButtonLayout } from '../../../v2BaseComponents/ActionButtonLayout';
import WelcomeHeader from './WelcomeHeader';
import Footer from './Footer';
import ScreenshotsCarousel from './ScreenshotsCarousel';
import AboutThisAppSection from './AboutThisAppSection';
import DataSafetySection from './DataSafetySection';
import MainContentContainer from '../../../v2BaseComponents/MainContentContainer';
import Stack from '../../../v2BaseComponents/Stack';
import { getSpacing } from '../../../../utils/spacing';
import ErrorBoundary from '../../../v2BaseComponents/ErrorBoundary';
import LoginButtons from './LoginButtons';

export type WebWelcomeScreenOwnProps = {};

export type WebWelcomeScreenProps = WebWelcomeScreenOwnProps;

const WebWelcomeScreen: React.FC<WebWelcomeScreenProps> = () => {
    return (
        <ErrorBoundary>
            <ActionButtonLayout scrollable restrictedWidthVariant="md">
                <MainContentContainer>
                    <Stack vertical space={getSpacing(6)}>
                        <WelcomeHeader />
                        <Stack
                            space={getSpacing(1)}
                            horizontal
                            style={{
                                width: '100%',
                            }}
                            testID="social-login-button-container"
                        >
                            <LoginButtons />
                        </Stack>
                        <ScreenshotsCarousel />
                        <AboutThisAppSection />
                        <DataSafetySection />
                        <Footer />
                    </Stack>
                </MainContentContainer>
            </ActionButtonLayout>
        </ErrorBoundary>
    );
};

export default React.memo(WebWelcomeScreen);
